// extracted by mini-css-extract-plugin
export default {"mainContainer":"istills_mainContainer__awFMI","leftSubContainer":"istills_leftSubContainer__gVNtt","rightSubContainer":"istills_rightSubContainer__NvSAC"};